import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import supplierService from "../services/supplierService";

// Create

const defaultSupplierState = {
  loading: false,
  data: null,
  error: null,
};

export const createSupplier = createAsyncThunk(
  "supplier/create",
  async (data) => {
    return await supplierService.create(data);
  }
);

const supplierCreateReducer = createSlice({
  name: "createSupplier",
  initialState: defaultSupplierState,
  extraReducers: (builder) => {
    builder.addCase(createSupplier.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createSupplier.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = "";
    });
    builder.addCase(createSupplier.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.error.message;
    });
  },
});

export const SupplierCreateReducer = supplierCreateReducer.reducer;

// List
const defaultSupplierListState = {
  loading: false,
  data: null,
  error: null,
};

export const supplierList = createAsyncThunk("supplier/list", async (data) => {
  return await supplierService.getList(data);
});

const supplierListReducer = createSlice({
  name: "supplierList",
  initialState: defaultSupplierListState,
  extraReducers: (builder) => {
    builder.addCase(supplierList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(supplierList.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = "";
    });
    builder.addCase(supplierList.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.error.message;
    });
  },
});

export const SupplierListReducer = supplierListReducer.reducer;

// Get
const defaultSupplierGetState = {
  loading: false,
  data: null,
  error: null,
};

export const getSupplier = createAsyncThunk("supplier/get", async (id) => {
  return await supplierService.getSupplier(id);
});

const supplierGetReducer = createSlice({
  name: "supplierGet",
  initialState: defaultSupplierGetState,
  extraReducers: (builder) => {
    builder.addCase(getSupplier.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSupplier.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = "";
    });
    builder.addCase(getSupplier.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.error.message;
    });
  },
});

export const SupplierGetReducer = supplierGetReducer.reducer;

// Update
const defaultSupplierUpdateState = {
  loading: false,
  data: null,
  error: null,
};

export const updateSupplier = createAsyncThunk(
  "supplier/update",
  async (data) => {
    return await supplierService.updateSupplier(data);
  }
);

const supplierUpdateReducer = createSlice({
  name: "supplierUpdate",
  initialState: defaultSupplierUpdateState,
  extraReducers: (builder) => {
    builder.addCase(updateSupplier.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateSupplier.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = "";
    });
    builder.addCase(updateSupplier.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.error.message;
    });
  },
});

export const SupplierUpdateReducer = supplierUpdateReducer.reducer;

// upload file
const defaultUploadFile = {
  loading: false,
  data: null,
  error: null,
};

export const uploadFile = createAsyncThunk("upload/file", async (data) => {
  const formData = new FormData();
  formData.append("file", data);
  return await supplierService.upload(formData);
});

const uploadFileReducer = createSlice({
  name: "uploadFile",
  initialState: defaultUploadFile,
  reducers: {
    reset: (state) => {
      state.loading = false;
      state.data = null;
      state.error = "";
    },
  },

  extraReducers: (builder) => {
    builder.addCase(uploadFile.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(uploadFile.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = "";
    });
    builder.addCase(uploadFile.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.error.message;
    });
  },
});

export const { reset } = uploadFileReducer.actions;
export const UploadFileReducer = uploadFileReducer.reducer;

// Delete
const defaultSupplierDelete = {
  loading: false,
  data: null,
  error: null,
};

export const deleteSupplier = createAsyncThunk(
  "supplier/update",
  async ({ id }) => {
    return await supplierService.deleteSupplier(id);
  }
);

const deleteSupplierReducer = createSlice({
  name: "deleteSupplier",
  initialState: defaultSupplierDelete,
  extraReducers: (builder) => {
    builder.addCase(deleteSupplier.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteSupplier.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = "";
    });
    builder.addCase(deleteSupplier.rejected, (state, action) => {
      state.loading = false;
      state.data = null;
      state.error = action.error.message;
    });
  },
});

export const DeleteSupplierReducer = deleteSupplierReducer.reducer;
